export enum OrganizationPlatformType {
  TABLELIST_PRO = 'TABLELIST_PRO',
}

export enum OrganizationType {
  LIMITED_EXTERNAL = 'LIMITED_EXTERNAL',
  STANDARD_VENUE = 'STANDARD_VENUE',
}

export enum OrganizationEvent {
  CREATED = 'ORGANIZATION_CREATED',
  NEW_ACCOUNT_SIGNUP_COMPLETED = 'ORGANIZATION_NEW_ACCOUNT_SIGNUP_COMPLETED',
  NEW_EXTERNAL_ACCOUNT_SIGNUP_COMPLETED = 'ORGANIZATION_NEW_EXTERNAL_ACCOUNT_SIGNUP_COMPLETED',
}

export enum ExternalAccountSignupSource {
  SELF_SIGNUP = 'SELF_SIGNUP',
  MANUAL_ADD = 'MANUAL_ADD',
}
